import errorManager from '@/rollbar.js';

const checkFields = (urlForDecodeTargets, urlForDecodeActions, urlForDecodeIndicators, urlForDesease) => {
  const areaId = $('#area').val();
  const deseaseId = $('#select-desease').val();
  const decodeTargetId = $('#tergets_list').val();
  const decodeActionId = $('#actions_list').val();
  const decodeIndicatorId = $('#indicators_list').val();

  let onLoad = true;

  $('#area').on('select2:select', function (e) {
    let areaId = e.params.data.id;
    setFields(
      areaId,
      urlForDecodeTargets,
      urlForDecodeActions,
      urlForDecodeIndicators,
      urlForDesease,
      deseaseId,
      decodeTargetId,
      decodeActionId,
      decodeIndicatorId,
    );
  });

  if (!areaId) {
    return;
  }

  if (onLoad) {
    setFields(
      areaId,
      urlForDecodeTargets,
      urlForDecodeActions,
      urlForDecodeIndicators,
      urlForDesease,
      deseaseId,
      decodeTargetId,
      decodeActionId,
      decodeIndicatorId,
    );
    onLoad = false;
  }
};

const setFields = function (
  areaId,
  urlForDecodeTargets,
  urlForDecodeActions,
  urlForDecodeIndicators,
  urlForDesease,
  deseaseId,
  decodeTargetId,
  decodeActionId,
  decodeIndicatorId,
) {
  let placeholder = [{ id: '', text: '' }];

  $.ajax({
    url: urlForDesease,
    data: {
      type_id_eq: areaId,
    },
    cache: false,
    type: 'GET',
    success: function (responsedDeseades) {
      let nuoviValori = responsedDeseades.map((item) => {
        return {
          id: item[1],
          text: item[0],
        };
      });

      // Ricreo select2 passando i nuovi dati
      $('#select-desease')
        .empty()
        .select2({
          theme: 'bootstrap',
          data: placeholder.concat(nuoviValori),
          placeholder: 'Select an option',
          allowClear: true,
        })
        .val(deseaseId);
    },
    error: function (xhr) {
      console.log('Errore nel caricamento delle aree');
    },
  });

  $.ajax({
    url: urlForDecodeTargets,
    data: {
      area_id: areaId,
    },
    cache: false,
    type: 'GET',
    success: function (responseDecode) {
      let nuoviValori = responseDecode.map((item) => {
        return {
          id: item.value,
          text: item.desc,
        };
      });

      // Ricreo select2 passando i nuovi dati
      $('#tergets_list')
        .empty()
        .select2({
          theme: 'bootstrap',
          data: placeholder.concat(nuoviValori),
          placeholder: 'Select an option',
          allowClear: true,
        })
        .val(decodeTargetId);
    },
    error: function (xhr) {
      console.log('Errore nel caricamento delle aree');
    },
  });

  $.ajax({
    url: urlForDecodeActions,
    data: {
      area_id: areaId,
    },
    cache: false,
    type: 'GET',
    success: function (responseDecode) {
      let nuoviValori = responseDecode.map((item) => {
        return {
          id: item.value,
          text: item.desc,
        };
      });

      // Ricreo select2 passando i nuovi dati
      $('#actions_list')
        .empty()
        .select2({
          theme: 'bootstrap',
          data: placeholder.concat(nuoviValori),
          placeholder: 'Select an option',
          allowClear: true,
        })
        .val(decodeActionId);
    },
    error: function (xhr) {
      console.log('Errore nel caricamento delle aree');
    },
  });

  $.ajax({
    url: urlForDecodeIndicators,
    data: {
      area_id: areaId,
    },
    cache: false,
    type: 'GET',
    success: function (responseDecode) {
      let nuoviValori = responseDecode.map((item) => {
        return {
          id: item.value,
          text: item.desc,
        };
      });

      // Ricreo select2 passando i nuovi dati
      $('#indicators_list')
        .empty()
        .select2({
          theme: 'bootstrap',
          data: placeholder.concat(nuoviValori),
          placeholder: 'Select an option',
          allowClear: true,
        })
        .val(decodeIndicatorId);
    },
    error: function (xhr) {
      console.log('Errore nel caricamento delle aree');
    },
  });
};

const init = (urlForDecodeTargets, urlForDecodeActions, urlForDecodeIndicators, urlForDesease) => {
  try {
    checkFields(urlForDecodeTargets, urlForDecodeActions, urlForDecodeIndicators, urlForDesease);
  } catch (e) {
    errorManager(e);
  }
};

window.AreaSelectForDeseaseAndTarget = {
  init: init,
};
